module.exports = __webpack_public_path__ + "img/tip-aquaplaning.ea0a2ff5.gif";